// SketchHost.jsx

import React from 'react';

import { useOptionalSketch } from 'context/SketchContext';
import SketchModal from 'nodetypes/sketch/SketchModal';

/**
 * SketchHost
 *
 * Renders the sketch modal when the provider has an open sketch.
 *
 * @returns {ReactNode}
 */
const SketchHost = () => {
  const sketch = useOptionalSketch();
  if (!sketch?.isSketchOpen) return null;
  return <SketchModal />;
};

SketchHost.displayName = 'SketchHost';

export default SketchHost;
